import type {RouteRecordRaw} from "vue-router";
import IconTrashStatus from '@/shared/ui/icons/document/DocumentTrash.vue';

export const routeName = 'Trash';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'trash',
    redirect: {
        name: 'TrashList',
    },
    meta: {
        title: 'status_trash',
        icon: IconTrashStatus,
        isNavTab: true,
    },
    children: [
        {
            name: 'TrashList',
            path: '',
            component: () => import('@/pages/TrashList'),
            meta: {
                isHide: true,
                title: 'status_trash'
            }
        },
        {
            name: 'TrashDoc',
            path: ':id(\\d+)',
            component: () => import('@/pages/Trash'),
            props: route => ({
                documentId: Number(route.params.id),
            }),
            meta: {
                isHide: true,
                title: 'status_trash'
            }
        }
    ]
};
